module.exports = __webpack_public_path__ + "img/mtb-new.7a090a68.png";